const translations_zh_TW = {
    'mc.serverCore.title': 'Minecraft 伺服器核心下載',
    'mc.serverCore.welcome': '歡迎使用 MSL 的伺服器端鏡像下載服務！',
    'mc.serverCore.description': '選擇適合您的 Minecraft 伺服器核心，支援插件、模組、原版等多種類型。',
    'mc.serverCore.categories': '伺服器分類',
    'mc.serverCore.selectType': '選擇您需要的伺服器類型',
    'mc.serverCore.selectCore': '選擇伺服器核心',
    'mc.serverCore.searchCore': '搜尋伺服器核心...',
    'mc.serverCore.versionList': '版本列表',
    'mc.serverCore.selectVersion': '選擇版本',
    'mc.serverCore.refresh': '重新整理',
    'mc.serverCore.startSelect': '開始選擇伺服器',
    'mc.serverCore.selectCategoryFirst': '請先選擇一個伺服器分類來檢視可用的核心。',
    'mc.serverCore.selectCoreFirst': '請先選擇一個伺服器核心',
    'mc.serverCore.server': '伺服器',
    'mc.serverCore.version': '版本',
    'mc.serverCore.fileVerification': '檔案校驗資訊',
    'mc.serverCore.downloadStarted': '下載已開始',
    'mc.serverCore.getCategoryFailed': '獲取伺服器分類失敗',
    'mc.serverCore.networkError': '網路錯誤，請稍後重試',
    'mc.serverCore.getVersionsFailed': '獲取版本列表失敗',
    'mc.serverCore.networkErrorVersions': '獲取版本列表時網路錯誤',
    'mc.serverCore.getDownloadLinkFailed': '獲取下載連結失敗',
    'mc.serverCore.networkErrorDownload': '下載時網路錯誤',
    'mc.serverCore.coreCount': '個核心',
    'mc.serverCore.loadingVersions': '正在載入版本...',
    'mc.serverCore.noVersionsFound': '未找到可用版本。',

    // 伺服器分類
    'mc.serverCore.pluginsCore': '插件伺服器',
    'mc.serverCore.pluginsCoreDesc': '支援 Bukkit/Spigot/Paper 插件的伺服器核心。',
    'mc.serverCore.pluginsAndModsCore_Forge': 'NeoForge 系混合伺服器',
    'mc.serverCore.pluginsAndModsCore_ForgeDesc': '同時支援 NeoForge/Forge 模組和插件的混合伺服器。',
    'mc.serverCore.pluginsAndModsCore_Fabric': 'Fabric 混合伺服器',
    'mc.serverCore.pluginsAndModsCore_FabricDesc': '同時支援 Fabric 模組和插件的混合伺服器。',
    'mc.serverCore.modsCore_Forge': 'NeoForge 模組伺服器',
    'mc.serverCore.modsCore_ForgeDesc': '專門用於執行 NeoForge/Forge 模組的伺服器核心。',
    'mc.serverCore.modsCore_Fabric': 'Fabric 模組伺服器',
    'mc.serverCore.modsCore_FabricDesc': '專門用於執行 Fabric 模組的伺服器核心。',
    'mc.serverCore.vanillaCore': '原版伺服器',
    'mc.serverCore.vanillaCoreDesc': 'Minecraft 官方原版伺服器核心。',
    'mc.serverCore.bedrockCore': '基岩版伺服器',
    'mc.serverCore.bedrockCoreDesc': '用於基岩版（手機版）的伺服器核心。',
    'mc.serverCore.proxyCore': '代理伺服器',
    'mc.serverCore.proxyCoreDesc': '用於連接多個伺服器的代理核心。',

    // 通用
    'common.confirm': '確認',
    'common.error': '錯誤',
    'common.notice': '提示',

    // 主题切换
    'theme.switcher': '主題',
    'theme.light': '淺色',
    'theme.dark': '深色',
    'theme.auto': '自動',

    // 服务归属信息
    'mc.serverCore.attribution': '本服務由<a href="https://github.com/MSLTeam" target="_blank" class="link-secondary">MSLTeam</a>提供，歡迎使用我們的<a href="https://www.mslmc.cn/" target="_blank" class="link-secondary">MSL開服器</a>，下載API來源<a href="https://www.mslmc.cn/docs/other/msl-mirrors.html" target="_blank" class="link-secondary">MSL-API-V3</a>。',

    // 页脚
    'footer.copyright': 'Copyright © MSLTeam 2021-2025 All Right Reserved.',
    'footer.icp': '粤ICP备2023094648号-2',
};